export default __webpack_public_path__ + "static/media/404.603ffe43.svg";